export const USER_STATUS = Object.freeze({
  isLogin: 'authenticated',
  isLogout: 'unauthenticated',
  loading: 'loading',
});
